'use client'

import { useEffect, useRef, useState } from 'react'

import { buildArticleShareUrl } from '@/lib/analytics/article-share'

export const useCopyArticleLink = () => {
  const [copyStatus, setCopyStatus] = useState<'idle' | 'copied' | 'error'>('idle')
  const resetTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(
    () => () => {
      if (resetTimer.current) {
        clearTimeout(resetTimer.current)
      }
    },
    []
  )

  const copyArticleLink = async () => {
    if (resetTimer.current) {
      clearTimeout(resetTimer.current)
    }
    try {
      await navigator.clipboard.writeText(buildArticleShareUrl(window.location.pathname, 'copy_link'))
      setCopyStatus('copied')
      resetTimer.current = setTimeout(() => setCopyStatus('idle'), 3000)
    } catch {
      setCopyStatus('error')
    }
  }

  return { copyStatus, copyArticleLink }
}
